module.exports = __webpack_public_path__ + "static/media/aosaPreview.cf57c3d9.jpg";